<div class="container-fluid position-relative m-0 p-0">
  <app-loading *ngIf="loading" style="position:absolute; top:50px; width:100%; background-color: rgba(255,255,255,0.95);"></app-loading>
  <div class="container">
    <div class="row">
      <div class="col-md-6 offset-md-3 my-2">
        <app-article-search></app-article-search>
        
        <div *ngIf="!loading && view=='search' && searchResults.length ==0" class="text-center text-uppercase">
          No results found.<br>Please try a different search term.
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="view=='list'" class="m-0 p-0">
<section id="introArticle">
    <div class="container">
    <div *ngIf=articleHeadline class="jumbotronIntroArticle p-3 p-md-5 text-white rounded">
        <div class="row">
        <div class="col-12 col-lg-6">
            <h1 class="display-4">{{articleHeadline.title}}</h1>
            <div class="mb-1 text-light"><small>{{articleHeadline.date | date: "MMM d, yyyy"}}</small></div>
            <div class="mb-1 text-light"><small>by {{articleHeadline.author}}</small></div>
          <div [innerHTML]="articleHeadline.teaser" class="lead my-3"></div>
          <p class="lead"><a routerLink="/articles/{{articleHeadline.friendlyUrl}}" class="fw-bold mb-5">Continue reading...</a></p>
        </div>
        <div class="col-12 col-lg-6 ">
        <img class="card-img-right d-xl-block img-fluid" src="{{articleHeadline.posterUrl}}" alt="{{articleHeadline.title}}">
        </div>
      </div>
        </div>
    </div>
    </section>

<section id="articlesList">
  <div class="container">
    <div class="row mb-2">

        <div *ngFor="let article of pageOfItems" class="col-md-6">     
         
          <app-article-card [data]="article"></app-article-card>
        </div>
        <div class="clearfix mt-2"></div>

        <div class="pt-2 col-md-12">
          <app-paginator [items]="articles" (changePage)="onChangePage($event)"></app-paginator> 
      </div>
    </div>
  </div>
</section>
</div>

<div *ngIf="view=='search'" class="m-0 p-0">
  <section id="articleSearchResults">
    <div class="container">
   
      <div class="row mb-2">

          <div *ngFor="let searchResult of searchResults" class="col-md-12">        
            <app-article-search-card [data]="searchResult"></app-article-search-card>
          </div>
          <div class="clearfix mt-2"></div>

      </div>
    </div>
  </section>
</div>